import React from 'react'

export default () => <>
  <main style={{
    fontFamily: 'Georgia, "Times New Roman", "DejaVu Serif", serif',
    fontSize: '16px'
  }}>
    <h1>Методические рекомендации</h1>
    <p style={{textAlign: 'right'}}>«Мне было трудно под это подрочить, но я это сделал!»</p>
    <p style={{textAlign: 'right'}}>
      <em>
        Коммент под роликом на ютубе, объясняющим<br/>
        основные принципы электромагнетизма.
      </em>
    </p>
    <p><em>Шорох, треск. Нрзб.</em></p>
    <p>
      …это прекрасная книга для обучения основам анализа и развития критического мышления вашего Внимательного Читателя. Задачи разделены по степени сложности: от простых («Как можно проебать сложившиеся финансовые каналы?», «Почему все интриги строятся по схемам борьбы за кафедральный пост?») до сложных («Какие исторические причины могут привести к созданию органа власти, не допускающего принятия решения путем простого большинства?»). К одним из основных достоинств следует отнести то, что эти задачи затрагивают широкий спектр наук и наукообразий, а не сосредотачиваются на каком-то одном (что, увы, не редкость в современной обучающей литературе). Внимательный Читатель сможет попытать свои силы в биологии и медицине, истории и антропологии, бюрократии и теологии. Следует заметить, что авторы разработали собственную систему обозначений: так, простые задачи на толерантность помечены тэгом «Габриэль Евгеньевич», а, например, упражнения по герменевтическому анализу когнитивных способностей предваряются записью «входят Охрович и Краснокаменный». (Впрочем, предложенная система настолько оригинальна, что мы не уверены, что в ней разобрались.)
    </p>
    <p>Книга предназначена для старшего студенческого возраста.</p>
    <p><em>…Раз-раз-раз…</em></p>
    <p>
      …а я ещё раз повторяю, что дело не в том, что Порт подозрительно похож на Муравейник, а то, что творит Дима — на то, что делает Бакалавр! Диктатуру постмодернизма никто пока ещё не отменял, и все эти игры с читателем «Ах, ну мы знаем, что вы это читали, но мы-то могли этого и не читать!» ещё полны подувядшей прелести. Дело в другом — всё тамошнее символическое поле — это моровская степь (если не считать ритуальной грядки с тотемами литературных предков — Лагеря и Революции). Все эти Мартины-Сорокины лишь поставляют элементы лука, в то время как Мор вовсю косплеится. Так что правила приличия требуют упомянуть.
    </p>
    <p><em>…не слышно.</em></p>
    <p>
      Ах, к чему эти утешения! Они бесполезны и смешны. Вся эта чехарда с фалангами
      и головами, хуями и Хуем, Пинегой и Столицей не стоят ничего. Охрович и
      Краснокаменный уехали в Афстралию! О, вечноускользающие трикстеры, совершенные
      воплощения Труляля и Трулюлю, в страусовых боа покидаете вы юдоль скорбей, и лишь
      одно дело остается незавершённым: открученная в Зоологическом голова чучела волка
      остается неводруженной — ни на такси, ни на кафедральное чучело.
    </p>
    <p>Пичалька.</p>
    <p><em>Затемнение.</em></p>
    <p><em>
      В комнату с ноги вламывается Внутренняя Девочка и стучит бутылкой пива по
      столу: «Я тррребую, чтобы в следующей серии Дима с Гуанако поженились!»
      Внутреннюю Девочку выводят. Слышны крики «…и Максим с Гошкой тоже!»
    </em></p>
    <h2>Вопросы для подготовки к семинару:</h2>
    <p>1. Предложите механизм работы вируса, имеющего 200-300 стадий развития, в
      предположении, что вирус встраивается в ДНК (РНК). Обоснуйте невозможность
      консервации.</p>
    <p>2. Являются ли фаланги deus ex machina? При каких исходных посылках они
      действуют по инструкции, а при каких — по понятиям? Докажите невозможность
      использования видеозаписи заражения.</p>
    <p>3. Был ли Гошка в момент передачи вируса Брови в перчатках? Является ли право во
      Всероссийском Соседстве прецедентным?</p>
    <p>4. Феномен синхронизации. Сравнительный анализ «Одного дня опричника» и «Чумы
      в Бедрограде».</p>
    <p>5. Эффект бабочки в контексте номинологии. «Спаситель Петрограда» и «Чума в
      Бедрограде».</p>
    <p>6. Куда из культуры тавров исчезли колокольчики?</p>
    <p>7. Расходы на модернизацию канализации и финансовая отчётность. Механизмы
      внутреннего аудита (минимум три).</p>
    <p>8. Пути эволюции преимущественно гетеросексуального сообщества в
      гомосексуальное. Где бляди, сэр?</p>
    <p>9. Как удалить картинки?</p>
    <p>10. Алхимические печи и генетический анализ. Является ли конфликт
      Всероссийского Соседства и Британии-Кассахии проявлением антагонизма двух
      близкородственных видов?</p>
    <p>11. Встретит Шарль хоббитов или Локи?</p>
    <p>12. А Максим с Гошкой поженятся?</p>
    <p>13. Авторы собрали в тексте <em>все</em> предметы своей любви: pro et contra.</p>
    <p style={{textAlign: 'right'}}><em>Умеренно анонимный специалист</em></p>
  </main>
  <footer>
    <img src='/images/site_footer.jpg' alt='' style={{
      maxWidth: '100vw'
    }} />
  </footer>
</>